import { doc, getDoc } from "firebase/firestore/lite";
import { db, generateFirebaseId } from "senf-shared";
import * as XLSX from "xlsx";

export const ids = [
  {
    id: "dino-1",
    index: "dino-1",
    credits: 1000,
  },
  {
    id: "dino-2",
    index: "dino-2",
    credits: 1000,
  },
  {
    id: "dino-3",
    index: "dino-3",
    credits: 1000,
  },
  {
    id: "dino-4",
    index: "dino-4",
    credits: 1000,
  },
  {
    id: "dino-5",
    index: "dino-5",
    credits: 1000,
  },
  {
    id: "dino-6",
    index: "dino-6",
    credits: 1000,
  },
  {
    id: "dino-7",
    index: "dino-7",
    credits: 1000,
  },
  {
    id: "dino-8",
    index: "dino-8",
    credits: 1000,
  },
  {
    id: "dino-9",
    index: "dino-9",
    credits: 1000,
  },
  {
    id: "dino-10",
    index: "dino-10",
    credits: 1000,
  },
  {
    id: "dino-11",
    index: "dino-11",
    credits: 1000,
  },
  {
    id: "dino-12",
    index: "dino-12",
    credits: 1000,
  },
  {
    id: "dino-13",
    index: "dino-13",
    credits: 1000,
  },
  {
    id: "dino-14",
    index: "dino-14",
    credits: 1000,
  },
  {
    id: "dino-15",
    index: "dino-15",
    credits: 1000,
  },
  {
    id: "dino-16",
    index: "dino-16",
    credits: 1000,
  },
  {
    id: "dino-17",
    index: "dino-17",
    credits: 1000,
  },
  {
    id: "dino-18",
    index: "dino-18",
    credits: 1000,
  },
  {
    id: "dino-19",
    index: "dino-19",
    credits: 1000,
  },
  {
    id: "dino-20",
    index: "dino-20",
    credits: 1000,
  },
  {
    id: "dino-21",
    index: "dino-21",
    credits: 1000,
  },
  {
    id: "dino-22",
    index: "dino-22",
    credits: 1000,
  },
  {
    id: "dino-23",
    index: "dino-23",
    credits: 1000,
  },
  {
    id: "dino-24",
    index: "dino-24",
    credits: 1000,
  },
  {
    id: "dino-25",
    index: "dino-25",
    credits: 1000,
  },
  {
    id: "dino-26",
    index: "dino-26",
    credits: 1000,
  },
  {
    id: "dino-27",
    index: "dino-27",
    credits: 1000,
  },
  {
    id: "dino-28",
    index: "dino-28",
    credits: 1000,
  },
  {
    id: "dino-29",
    index: "dino-29",
    credits: 1000,
  },
  {
    id: "dino-30",
    index: "dino-30",
    credits: 1000,
  },
  {
    id: "lY1vKM1Hzc5MBjK6HROe",
    index: "trial customer 1",
    credits: 250,
    name: "hkk",
  },
  {
    id: "testing123",
    index: "testing-0",
    credits: 1000,
  },
  {
    id: "lvj-1",
    index: "lvj-1",
    credits: 50,
  },
  {
    id: "lvj-2",
    index: "lvj-2",
    credits: 50,
  },
  {
    id: "lvj-3",
    index: "lvj-3",
    credits: 50,
  },
  {
    id: "lvj-4",
    index: "lvj-4",
    credits: 50,
  },
  {
    id: "lvj-5",
    index: "lvj-5",
    credits: 50,
  },
  {
    id: "lvj-6",
    index: "lvj-6",
    credits: 50,
  },
  {
    id: "lvj-7",
    index: "lvj-7",
    credits: 50,
  },
  {
    id: "lvj-8",
    index: "lvj-8",
    credits: 50,
  },
  {
    id: "lvj-9",
    index: "lvj-9",
    credits: 50,
  },
  {
    id: "lvj-10",
    index: "lvj-10",
    credits: 50,
  },
  {
    id: "lvj-11",
    index: "lvj-11",
    credits: 50,
  },
  {
    id: "lvj-12",
    index: "lvj-12",
    credits: 50,
  },
  {
    id: "lvj-13",
    index: "lvj-13",
    credits: 50,
  },
  {
    id: "lvj-14",
    index: "lvj-14",
    credits: 50,
  },
  {
    id: "lvj-15",
    index: "lvj-15",
    credits: 50,
  },
  {
    id: "lvj-16",
    index: "lvj-16",
    credits: 50,
  },
  {
    id: "lvj-17",
    index: "lvj-17",
    credits: 50,
  },
  {
    id: "lvj-18",
    index: "lvj-18",
    credits: 50,
  },
  {
    id: "lvj-19",
    index: "lvj-19",
    credits: 50,
  },
  {
    id: "lvj-20",
    index: "lvj-20",
    credits: 50,
  },
  {
    id: "workshop-1",
    index: "workshop-1",
    credits: 1000,
  },
  {
    id: "workshop-2",
    index: "workshop-2",
    credits: 1000,
  },
  {
    id: "workshop-3",
    index: "workshop-3",
    credits: 1000,
  },
  {
    id: "workshop-4",
    index: "workshop-4",
    credits: 1000,
  },
  {
    id: "workshop-5",
    index: "workshop-5",
    credits: 1000,
  },
  {
    id: "workshop-6",
    index: "workshop-6",
    credits: 1000,
  },
  {
    id: "workshop-7",
    index: "workshop-7",
    credits: 1000,
  },
  {
    id: "workshop-8",
    index: "workshop-8",
    credits: 1000,
  },
  {
    id: "workshop-9",
    index: "workshop-9",
    credits: 1000,
  },
  {
    id: "workshop-10",
    index: "workshop-10",
    credits: 1000,
  },
  {
    id: "workshop-11",
    index: "workshop-11",
    credits: 1000,
  },
  {
    id: "workshop-12",
    index: "workshop-12",
    credits: 1000,
  },
  {
    id: "workshop-13",
    index: "workshop-13",
    credits: 1000,
  },
  {
    id: "workshop-14",
    index: "workshop-14",
    credits: 1000,
  },
  {
    id: "workshop-15",
    index: "workshop-15",
    credits: 1000,
  },
  {
    id: "workshop-16",
    index: "workshop-16",
    credits: 1000,
  },
  {
    id: "workshop-17",
    index: "workshop-17",
    credits: 1000,
  },
  {
    id: "workshop-18",
    index: "workshop-18",
    credits: 1000,
  },
  {
    id: "workshop-19",
    index: "workshop-19",
    credits: 1000,
  },
  {
    id: "workshop-20",
    index: "workshop-20",
    credits: 1000,
  },
  {
    id: "workshop-100",
    index: "workshop-100",
    credits: 1000,
  },

  {
    id: "workshop-101",
    index: "workshop-101",
    credits: 1000,
  },
  {
    id: "workshop-102",
    index: "workshop-102",
    credits: 1000,
  },
  {
    id: "workshop-103",
    index: "workshop-103",
    credits: 1000,
  },
  {
    id: "workshop-104",
    index: "workshop-104",
    credits: 1000,
  },
  {
    id: "workshop-105",
    index: "workshop-105",
    credits: 1000,
  },
  {
    id: "workshop-106",
    index: "workshop-106",
    credits: 1000,
  },
  {
    id: "workshop-107",
    index: "workshop-107",
    credits: 1000,
  },
  {
    id: "workshop-108",
    index: "workshop-108",
    credits: 1000,
  },
  {
    id: "workshop-109",
    index: "workshop-109",
    credits: 1000,
  },
  {
    id: "workshop-110",
    index: "workshop-110",
    credits: 1000,
  },
  {
    id: "workshop-111",
    index: "workshop-111",
    credits: 1000,
  },
  {
    id: "workshop-112",
    index: "workshop-112",
    credits: 1000,
  },
  {
    id: "workshop-113",
    index: "workshop-113",
    credits: 1000,
  },
  {
    id: "workshop-114",
    index: "workshop-114",
    credits: 1000,
  },
  {
    id: "workshop-115",
    index: "workshop-115",
    credits: 1000,
  },
  {
    id: "workshop-116",
    index: "workshop-116",
    credits: 1000,
  },
  {
    id: "workshop-117",
    index: "workshop-117",
    credits: 1000,
  },
  {
    id: "workshop-118",
    index: "workshop-118",
    credits: 1000,
  },
  {
    id: "workshop-119",
    index: "workshop-119",
    credits: 1000,
  },
  {
    id: "workshop-120",
    index: "workshop-120",
    credits: 1000,
  },
  {
    id: "workshop-121",
    index: "workshop-121",
    credits: 1000,
  },
  {
    id: "workshop-122",
    index: "workshop-122",
    credits: 1000,
  },
  {
    id: "workshop-123",
    index: "workshop-123",
    credits: 1000,
  },
  {
    id: "workshop-124",
    index: "workshop-124",
    credits: 1000,
  },
  {
    id: "workshop-125",
    index: "workshop-125",
    credits: 1000,
  },
  {
    id: "workshop-126",
    index: "workshop-126",
    credits: 1000,
  },
  {
    id: "workshop-127",
    index: "workshop-127",
    credits: 1000,
  },
  {
    id: "workshop-128",
    index: "workshop-128",
    credits: 1000,
  },
  {
    id: "workshop-129",
    index: "workshop-129",
    credits: 1000,
  },
  {
    id: "workshop-130",
    index: "workshop-130",
    credits: 1000,
  },

  {
    id: "code123",
    index: "senf-0",
    credits: 1100,
  },
  {
    id: "code234",
    index: "senf-0",
    credits: 10000,
  },
  {
    id: "code345",
    index: "senf-0",
    credits: 10000,
  },
  {
    id: "code456",
    index: "senf-0",
    credits: 10000,
  },
  {
    id: "code567",
    index: "senf-0",
    credits: 10000,
  },
  {
    id: "IYIa9wN4Y5eZ8VzZIRMX",
    index: "senf-1",
    credits: 1000,
  },
  {
    id: "S6aaHVXwvT5lfdvf3uuO",
    index: "senf-2",
    credits: 1000,
  },
  {
    id: "728Rv19iLr9Q7u2NbnJ9",
    index: "senf-3",
    credits: 1000,
  },
  {
    id: "8s4cTSGolwIkbpQQGWPH",
    index: 4,
    credits: 50,
  },
  {
    id: "nI5jxc0VpbSDI1OhsX20",
    index: 5,
    credits: 50,
  },
  {
    id: "1bwL8pB5JP0K52MFzblN",
    index: 6,
    credits: 50,
  },
  {
    id: "tunHnHHjchcl6BtBZEWq",
    index: 7,
    credits: 50,
  },
  {
    id: "ZPZKJmlLemMGlwG6wZd2",
    index: 8,
    credits: 50,
  },
  {
    id: "UDsn0h3hxpZAuPVzhJwO",
    index: 9,
    credits: 50,
  },
  {
    id: "qsHZ81EoP2CiwjIeDitt",
    index: 10,
    credits: 50,
  },
  {
    id: "AE3oz9gIo7tYmxV7SPl0",
    index: 11,
    credits: 50,
  },
  {
    id: "kGVVGgFxLTdoziCDlzHC",
    index: 12,
    credits: 50,
  },
  {
    id: "QnhSjeGACC2iojODqWWQ",
    index: 13,
    credits: 50,
  },
  {
    id: "XC79aNnvPdIADdBDabBT",
    index: 14,
    credits: 50,
  },
  {
    id: "IVG82XqAALFH0F6neNJf",
    index: 15,
    credits: 50,
  },
  {
    id: "CqnXKKmRUZbSQ5MP6Zlt",
    index: 16,
    credits: 50,
  },
  {
    id: "rLRR9PMJDKRhrFsCvtme",
    index: 17,
    credits: 50,
  },
  {
    id: "BVP5Trrcm0LtmoLDPsmy",
    index: 18,
    credits: 50,
  },
  {
    id: "4P3JNDoLcxRAKoqoZMJP",
    index: 19,
    credits: 50,
  },
  {
    id: "pRHT3nFckATkalCoOlzN",
    index: 20,
    credits: 50,
  },
  {
    id: "wWkDQw8vbIJUaJsM4T7v",
    index: 21,
    credits: 50,
  },
  {
    id: "SWXr553fIAQKvzsVOM9t",
    index: 22,
    credits: 50,
  },
  {
    id: "tms0y1EhUKwtTEGzt2hz",
    index: 23,
    credits: 50,
  },
  {
    id: "tTzgzKE6qXXkreFUmiHk",
    index: 24,
    credits: 50,
  },
  {
    id: "XIBw6OjL1s1IWYhJ7wmw",
    index: 25,
    credits: 50,
  },
  {
    id: "CciQWmpWxuF24yEySKx0",
    index: 26,
    credits: 50,
  },
  {
    id: "7lt0Hs039NlH3yA98ZfJ",
    index: 27,
    credits: 50,
  },
  {
    id: "aYCvUV1MLn6B8eFrTDWr",
    index: 28,
    credits: 50,
  },
  {
    id: "FvxgdQAt3m8N2FkKLSu7",
    index: 29,
    credits: 50,
  },
  {
    id: "6CZ1gIl1anHHuQDyMzdY",
    index: 30,
    credits: 50,
  },
  {
    id: "uzi7rv2o03988QmVqEzZ",
    index: 31,
    credits: 50,
  },
  {
    id: "qi7aUtIRvD5Xek6zxq5R",
    index: 32,
    credits: 50,
  },
  {
    id: "OGOwGWQF4XobMIVFBsbc",
    index: 33,
    credits: 50,
  },
  {
    id: "F4SexE9HB1HfBtM6YNL8",
    index: 34,
    credits: 50,
  },
  {
    id: "TPRCML2TIN6BPqiC0eoJ",
    index: 35,
    credits: 50,
  },
  {
    id: "f0gtxVmvxgadQMhjBq2D",
    index: 36,
    credits: 50,
  },
  {
    id: "VjVd2hz9n7wfLMfcDko7",
    index: 37,
    credits: 50,
  },
  {
    id: "a9yeyHasVVamKQrU2pFa",
    index: 38,
    credits: 50,
  },
  {
    id: "Ie4L2Mvwhb1T79mcPdDU",
    index: 39,
    credits: 50,
  },
  {
    id: "96NPWy8LOpc4osX6bRTb",
    index: 40,
    credits: 50,
  },
  {
    id: "Gg2qUmYv7FI13NN3PG4W",
    index: 41,
    credits: 50,
  },
  {
    id: "GqKNpqm9GZxvDXXvZlcz",
    index: 42,
    credits: 50,
  },
  {
    id: "XQ9wU2IO84G2HhEwYJhk",
    index: 43,
    credits: 50,
  },
  {
    id: "ZvCeDGQQlYWcRjXEWezQ",
    index: 44,
    credits: 50,
  },
  {
    id: "sh8rntclhVyF2f8SreHX",
    index: 45,
    credits: 50,
  },
  {
    id: "3G00Q8e6QV30tIHIiDsI",
    index: 46,
    credits: 50,
  },
  {
    id: "JuUTWoceUg2eDjeR5Imx",
    index: 47,
    credits: 50,
  },
  {
    id: "vtmrduTezcQdDrEovRvt",
    index: 48,
    credits: 50,
  },
  {
    id: "In2TueX32J8ghPNcj3yO",
    index: 49,
    credits: 50,
  },
  {
    id: "ahd7fbv0grUFws4zRWT2",
    index: 50,
    credits: 50,
  },
  {
    id: "em24zF8kKS6Ffk1yNSpE",
    index: 51,
    credits: 50,
  },
  {
    id: "fuOqpvPGPNrjny061OfX",
    index: 52,
    credits: 50,
  },
  {
    id: "iIAuRrw8N5RjRlEHfAz1",
    index: 53,
    credits: 50,
  },
  {
    id: "tvAm1LqtIdyJ0bUhgtQJ",
    index: 54,
    credits: 50,
  },
  {
    id: "MhZb9rUDj6NUjSa6why2",
    index: 55,
    credits: 50,
  },
  {
    id: "ir6ZGEsIOz6f3m1CorT7",
    index: 56,
    credits: 50,
  },
  {
    id: "Gfa6WaPscUsfOJdy9G5j",
    index: 57,
    credits: 50,
  },
  {
    id: "2yYOyD2aVZpswMIzVGPd",
    index: 58,
    credits: 50,
  },
  {
    id: "JzA0CV3CWqGYLBXBA0sG",
    index: 59,
    credits: 50,
  },
  {
    id: "nRKusNySjxzWastTVAK6",
    index: 60,
    credits: 50,
  },
  {
    id: "HZlNU56OdH5XjNSbpswf",
    index: 61,
    credits: 50,
  },
  {
    id: "jt8GSgkB2OqtFjicquZj",
    index: 62,
    credits: 50,
  },
  {
    id: "fg4yYAq7CZzHfMMNR6cc",
    index: 63,
    credits: 50,
  },
  {
    id: "ZVGTG4ZldISgEmf2B0i0",
    index: 64,
    credits: 1000,
    name: "Gehl",
  },
  {
    id: "YFlfbXGFoi4dMZw8gj4B",
    index: 65,
    credits: 50,
  },
  {
    id: "NIxI3gQYpWQkpBhQrqZt",
    index: 66,
    credits: 50,
  },
  {
    id: "VsTbXtUyf2cvhXT9FIM5",
    index: 67,
    credits: 50,
  },
  {
    id: "gefyZzM8C6KPNZ79igwC",
    index: 68,
    credits: 50,
  },
  {
    id: "XDd0QnNDDKsU2Hcqdq4U",
    index: 69,
    credits: 50,
  },
  {
    id: "TRuJRjn7SstRg1NNc0gI",
    index: 70,
    credits: 50,
  },
  {
    id: "2D2PRg2F5eB7c0WRsMrc",
    index: 71,
    credits: 50,
  },
  {
    id: "HzvYviOFsRqsIhlZS2NK",
    index: 72,
    credits: 50,
  },
  {
    id: "ih3omV90NwM9TBIi5wQe",
    index: 73,
    credits: 50,
  },
  {
    id: "aMkyVsxsfsJlZ6AYFlQL",
    index: 74,
    credits: 50,
  },
  {
    id: "FA9rVyqJHx9On1x9EpAY",
    index: 75,
    credits: 50,
  },
  {
    id: "TbGL3yWNS1uaexaaRB17",
    index: 76,
    credits: 50,
  },
  {
    id: "C5W56Q1Ihc2M0Ea4Dn1f",
    index: 77,
    credits: 50,
  },
  {
    id: "dt6PjIcdDxADILsWoLR8",
    index: 78,
    credits: 50,
  },
  {
    id: "zktwG9GYS8Y9m5MZsyq7",
    index: 79,
    credits: 50,
  },
  {
    id: "IVDXvwY5boPd2JhRGjQ9",
    index: 80,
    credits: 50,
  },
  {
    id: "fbYzoAah12pLGLiXLLvR",
    index: 81,
    credits: 50,
  },
  {
    id: "4vE9yJmumdPQ1JUwROwk",
    index: 82,
    credits: 50,
  },
  {
    id: "JmdtK8wfpcgVUlUSv5I6",
    index: 83,
    credits: 50,
  },
  {
    id: "CPJE3CyzIQp21NiDGRNz",
    index: 84,
    credits: 50,
  },
  {
    id: "c2ie9ZwCIf9OjznIL3D5",
    index: 85,
    credits: 50,
  },
  {
    id: "Xq6IoviAOycS9bLx2HhG",
    index: 86,
    credits: 50,
  },
  {
    id: "oJn76RfF77EN5R1Y7zYk",
    index: 87,
    credits: 50,
  },
  {
    id: "t1jOBPtnL44uOaYkAUUJ",
    index: 88,
    credits: 50,
  },
  {
    id: "duDpTYdjydanwWemdWIJ",
    index: 89,
    credits: 50,
  },
  {
    id: "tQpQJcLwtK9qopajo7wG",
    index: 90,
    credits: 50,
  },
  {
    id: "FeZCuZKBG5QI6xrznp7i",
    index: 91,
    credits: 50,
  },
  {
    id: "jq08PSq168DIY4KDL3o8",
    index: 92,
    credits: 50,
  },
  {
    id: "n770AEh9kaCyvtf9mjpd",
    index: 93,
    credits: 50,
  },
  {
    id: "F7XzIbllpqOk0HrW4htA",
    index: 94,
    credits: 50,
  },
  {
    id: "7RwiJeNonxYqld6JPA5v",
    index: 95,
    credits: 50,
  },
  {
    id: "y8noyRoSevGIKLb8Bf7X",
    index: 96,
    credits: 50,
  },
  {
    id: "WwPrY1SfSf3MJrOCxDBb",
    index: 97,
    credits: 50,
  },
  {
    id: "84lVwHQ2XefjjtEr9O3w",
    index: 98,
    credits: 50,
  },
  {
    id: "p4ENKsXGUydB9MjTr1pW",
    index: 99,
    credits: 50,
  },
  {
    id: "XKLTzwA2wC8v63eADjkd",
    index: 100,
    credits: 50,
  },

  {
    id: "tUaUIqYYb81eZCqU25CV",
    index: "waitlist 1",
    credits: 50,
    email: "tassilomorino@hotmail.de",
    createdAt: "2023-12-06T11:56:00.364Z",
  },
  {
    id: "eGTl7jfdbr77cThxGHE7",
    index: "waitlist 2",
    credits: 50,
    email: "tassilomorino@gmail.com",
    createdAt: "2023-12-06T11:56:24.449Z",
  },
  {
    id: "2ckJEvI4R0VN47yiCKYM",
    index: "waitlist 3",
    credits: 50,
    email: "tassilomorino@mail.com",
    createdAt: "2023-12-06T11:56:59.733Z",
  },
  {
    id: "lGktvpIam0w1zCFjpGST",
    index: "waitlist 4",
    credits: 50,
    email: "joannapodszus@gmail.com",
    createdAt: "2023-12-06T15:30:04.699Z",
  },
  {
    id: "vmab2fVL8dD57dXDT4El",
    index: "waitlist 5",
    credits: 50,
    email: "tassilomorino@hotmail.de",
    createdAt: "2023-12-06T17:16:52.051Z",
  },
  {
    id: "RbJor3yhTJW4zDoZahs9",
    index: "waitlist 6",
    credits: 50,
    email: "tassilo.morino@senf.app",
    createdAt: "2023-12-08T15:01:09.579Z",
  },
  {
    id: "NpSTYnXjCXD3ZibPVcvq",
    index: "waitlist 7",
    credits: 50,
    email: "tassilomorino@hotmail.de",
    createdAt: "2023-12-08T15:01:59.014Z",
  },
  {
    id: "gwxBqpZbV9VulqoLX1RS",
    index: "waitlist 8",
    credits: 50,
    email: "tassilo.morino@senf.app",
    createdAt: "2023-12-08T15:04:19.537Z",
  },
  {
    id: "yTXynZcOk0cawfvbEvZx",
    index: "waitlist 9",
    credits: 50,
    email: "martin@herrndorf.de",
    createdAt: "2024-01-22T12:37:36.189Z",
  },
  {
    id: "BK5Bu3k4ylhwOQ48xfKZ",
    index: "waitlist 10",
    credits: 50,
    email: "julianhofmann@posteo.de",
    createdAt: "2024-01-22T18:22:20.650Z",
  },
  {
    id: "McnhZ1jVR2dkRnHSKzlh",
    index: "waitlist 11",
    credits: 50,
    email: "goepfert_philipp@posteo.de",
    createdAt: "2024-01-23T12:00:44.637Z",
  },
  {
    id: "sFajUDdr960eNOltYAMm",
    index: "waitlist 12",
    credits: 50,
    email: "jonas.call@rwth-aachne.de",
    createdAt: "2024-01-23T14:03:43.296Z",
  },
  {
    id: "xT9gXGgyPONgkaZwtHrs",
    index: "waitlist 13",
    credits: 50,
    email: "lukas.weitz@energieagentur.rlp.de",
    createdAt: "2024-01-23T14:59:11.601Z",
  },
  {
    id: "q6IoHLjuE02ngLRFKMNP",
    index: "waitlist 14",
    credits: 50,
    email: "lucca.backhaus@posteo.de",
    createdAt: "2024-01-23T15:58:41.874Z",
  },
  {
    id: "MmzTLxfP7Lr66dDEfaX8",
    index: "waitlist 15",
    credits: 50,
    email: "moessel@gmail.com",
    createdAt: "2024-01-24T06:58:16.379Z",
  },
  {
    id: "biCdvlXfebpVRELLwlxn",
    index: "waitlist 16",
    credits: 50,
    email: "wetzel@sippelbuff.de",
    createdAt: "2024-01-24T12:47:54.608Z",
  },
  {
    id: "gIXrNplinv2eRLt7wyFh",
    index: "waitlist 17",
    credits: 50,
    email: "johannes.gross89@googlemail.com",
    createdAt: "2024-01-24T15:13:28.954Z",
  },
  {
    id: "WWaxAZbeVrsrAzz1kFkJ",
    index: "waitlist 18",
    credits: 50,
    email: "hofmann@kommunikationsbuero.com",
    createdAt: "2024-01-24T15:31:04.248Z",
  },
  {
    id: "M2rwUb8BoaujQNsbaY5y",
    index: "waitlist 19",
    credits: 50,
    email: "erfrischendmysterioeserloewe@papierkorb.me",
    createdAt: "2024-01-24T15:31:15.464Z",
  },
  {
    id: "JBZla1ybUW14HXTU3chm",
    index: "waitlist 20",
    credits: 50,
    email: "eric.finke-engels@stud.uni-hannover.de",
    createdAt: "2024-01-24T15:34:16.154Z",
  },
  {
    id: "mJkLzJmTE5aNJnVBrm9r",
    index: "waitlist 21",
    credits: 50,
    email: "eric.finke-engels@stud.uni-hannover.de",
    createdAt: "2024-01-24T15:34:48.737Z",
  },
  {
    id: "00RL3fe9BVASeRSwct90",
    index: "waitlist 22",
    credits: 50,
    email: "JKunkel_123@web.de",
    createdAt: "2024-01-24T15:36:22.609Z",
  },
  {
    id: "oxRBkzyTp08BW8L374ml",
    index: "waitlist 23",
    credits: 50,
    email: "mbonafede@comune.vicenza.it",
    createdAt: "2024-01-24T20:04:38.378Z",
  },
  {
    id: "4RfNkq6qkI9lRelMp9nW",
    index: "waitlist 24",
    credits: 50,
    email: "highwall69@gmail.com",
    createdAt: "2024-01-25T09:18:32.445Z",
  },
  {
    id: "86Y3Soz9y5ud6aT6mbOD",
    index: "waitlist 25",
    credits: 50,
    email: "hendrik.stamm@outlook.com",
    createdAt: "2024-01-25T12:41:52.245Z",
  },
  {
    id: "TvmhF6oJ6XVPrihTrnqg",
    index: "waitlist 26",
    credits: 50,
    email: "lbackhaus@bochum.de",
    createdAt: "2024-01-25T13:34:24.572Z",
  },
  {
    id: "Mr8bBh7IDW9dzJ8LdREb",
    index: "waitlist 27",
    credits: 50,
    email: "davidtrash@web.de",
    createdAt: "2024-01-25T14:32:47.929Z",
  },
  {
    id: "46H87Cwcv7SJAc8bLbiw",
    index: "waitlist 28",
    credits: 50,
    email: "fgrendele@comune.vicenza.it",
    createdAt: "2024-01-25T14:32:52.642Z",
  },
  {
    id: "CLcssB2jVr4eIodTPjcb",
    index: "waitlist 29",
    credits: 50,
    email: "thorsten@lampe.team",
    createdAt: "2024-01-25T15:47:19.008Z",
  },
  {
    id: "8hgSDDxZm91IX4gRoikU",
    index: "waitlist 30",
    credits: 50,
    email: "JKunkel_123@web.de",
    createdAt: "2024-01-26T08:20:59.589Z",
  },
  {
    id: "QJZkSqh6fhTs0TfFH3e5",
    index: "waitlist 31",
    credits: 50,
    email: "dahlia.busch@stadt.neuss.de",
    createdAt: "2024-01-26T12:27:53.619Z",
  },
  {
    id: "U1TgrQdFi3Hm1nUFljRg",
    index: "waitlist 32",
    credits: 50,
    email: "philipp.heidkamp@gmail.com",
    createdAt: "2024-01-26T14:58:35.549Z",
  },
  {
    id: "TGPQiwupujzG0jnisAVx",
    index: "waitlist 33",
    credits: 50,
    email: "info@felixzelck.de",
    createdAt: "2024-01-26T20:44:07.680Z",
  },
  {
    id: "hggQbN2VsApDbKGppTDo",
    index: "waitlist 34",
    credits: 50,
    email: "marcodemitri@gmail.com",
    createdAt: "2024-01-27T17:57:41.109Z",
  },
  {
    id: "Q7hhZIebfxdFypuI8fb9",
    index: "waitlist 35",
    credits: 50,
    email: "marco.demitri@trafficlab.eu",
    createdAt: "2024-01-27T17:58:08.929Z",
  },
  {
    id: "atDtUZQS4fcZhjZHggQB",
    index: "waitlist 36",
    credits: 50,
    email: "alessandra.martignoni01@gmail.com",
    createdAt: "2024-01-28T08:40:51.084Z",
  },
  {
    id: "tmvowmqCWBQ4dd0FpjG5",
    index: "waitlist 37",
    credits: 50,
    email: "matteo.divenosa@unich.it",
    createdAt: "2024-01-28T10:04:50.584Z",
  },
  {
    id: "kJGbELrWeEMawcUXrSB4",
    index: "waitlist 38",
    credits: 50,
    email: "gpapadopoli@gmail.com",
    createdAt: "2024-01-28T12:01:14.618Z",
  },
  {
    id: "QHGkDO4DGT8kW2G5F4X0",
    index: "waitlist 39",
    credits: 50,
    email: "andrea.zippone@comune.milano.it",
    createdAt: "2024-01-28T15:25:21.403Z",
  },
  {
    id: "CI4q7NdMlBT2FSj8btmU",
    index: "waitlist 40",
    credits: 50,
    email: "cosimo.chiffi@gmail.com",
    createdAt: "2024-01-28T16:50:04.144Z",
  },
  {
    id: "PUITTsBqDX01eUYr7cBW",
    index: "waitlist 41",
    credits: 50,
    email: "ste.ragazzo@gmail.com",
    createdAt: "2024-01-28T19:40:11.501Z",
  },
  {
    id: "sNXpxngPTq6LdOpQmtVC",
    index: "waitlist 42",
    credits: 50,
    email: "cecchetti.fr@gmail.com",
    createdAt: "2024-01-28T20:23:32.869Z",
  },
  {
    id: "2rUcuPN5l7ttKd3x1gf8",
    index: "waitlist 43",
    credits: 50,
    email: "dirittideipedoni@gmail.com",
    createdAt: "2024-01-28T22:22:46.929Z",
  },
  {
    id: "T8VTgQisaBjjAeWEwjoe",
    index: "waitlist 44",
    credits: 50,
    email: "nadia.giuffrida@poliba.it",
    createdAt: "2024-01-29T07:45:05.849Z",
  },
  {
    id: "DYP0ih0OlUIXnHy87bjx",
    index: "waitlist 45",
    credits: 50,
    email: "fedelia26@gmail.com",
    createdAt: "2024-01-29T08:06:25.205Z",
  },
  {
    id: "aVGJROj8Lv1lrzigfbz1",
    index: "waitlist 46",
    credits: 50,
    email: "fabriziapetrei@gmail.com ",
    createdAt: "2024-01-29T08:15:30.742Z",
  },
  {
    id: "rXhO3ozm2T45l2cXsIxh",
    index: "waitlist 47",
    credits: 50,
    email: "vincent.busche@adfc.de",
    createdAt: "2024-01-29T08:44:30.152Z",
  },
  {
    id: "HZU10ryCxyKTGOkIXyGK",
    index: "waitlist 48",
    credits: 50,
    email: "Tivano777@gmail.com",
    createdAt: "2024-01-29T09:29:45.558Z",
  },
  {
    id: "6TVPKVq6b9cgOc0yur6V",
    index: "waitlist 49",
    credits: 50,
    email: "e.ooms@mobycon.com",
    createdAt: "2024-01-29T11:08:08.991Z",
  },
  {
    id: "25db40XgJxeGc7z8098g",
    index: "waitlist 50",
    credits: 50,
    email: "max.schierholz@gmail.com",
    createdAt: "2024-01-29T13:22:28.052Z",
  },
  {
    id: "2WGfor3NSnkUHVreys3T",
    index: "waitlist 51",
    credits: 50,
    email: "highwall69@gmail.com",
    createdAt: "2024-01-29T16:27:41.678Z",
  },
  {
    id: "g91MX3DpaJOOvE2TOUug",
    index: "waitlist 52",
    credits: 50,
    email: "gobbibike@gmail.com",
    createdAt: "2024-01-29T16:30:40.876Z",
  },
  {
    id: "fqAT8ybWBgpi0v64IfXf",
    index: "waitlist 53",
    credits: 50,
    email: "giovanna.bellicini@gmail.com",
    createdAt: "2024-01-30T08:20:23.654Z",
  },
  {
    id: "GWMNCvUeMxxLF4WyjVNA",
    index: "waitlist 54",
    credits: 50,
    email: "simone.cannarsa@gmail.com",
    createdAt: "2024-01-30T08:53:56.087Z",
  },
  {
    id: "kF5p0LZd4pfKTPeTr2if",
    index: "waitlist 55",
    credits: 50,
    email: "micdabe@gmail.com",
    createdAt: "2024-01-31T09:06:30.269Z",
  },
  {
    id: "xqYr2hSiVc85to1PplWc",
    index: "waitlist 56",
    credits: 50,
    email: "tim.lochschmidt@munv.nrw.de",
    createdAt: "2024-01-31T10:15:58.321Z",
  },
  {
    id: "WYQF4Hi2DNkw1xsCpdMX",
    index: "waitlist 57",
    credits: 50,
    email: "anina.schulz@dayone.de",
    createdAt: "2024-01-31T12:32:46.291Z",
  },
  {
    id: "2YRWfD4LtR7VyC6LsUdq",
    index: "waitlist 58",
    credits: 50,
    email: "sprengel.charlotte@gmail.com",
    createdAt: "2024-01-31T18:49:43.446Z",
  },
  {
    id: "MLZcjybjYz3Zkrdz5cUE",
    index: "waitlist 59",
    credits: 50,
    email: "blum@nexusinstitut.de",
    createdAt: "2024-02-01T09:46:06.734Z",
  },
  {
    id: "JAr4zrsiUrWGmh7wvo5v",
    index: "waitlist 60",
    credits: 50,
    email: "Lravanello@gmail.con",
    createdAt: "2024-02-01T23:58:08.874Z",
  },
  {
    id: "U51kYbHA4DwUMzgBSFFK",
    index: "waitlist 61",
    credits: 50,
    email: "giuseppecolonna19@gmail.com",
    createdAt: "2024-02-02T15:25:05.106Z",
  },
  {
    id: "xOZMUVOt0b8Zu65Snozo",
    index: "waitlist 62",
    credits: 50,
    email: "gaia.sgaramella@gmail.com",
    createdAt: "2024-02-04T10:10:09.331Z",
  },
  {
    id: "r2gjZ9M1TyVNuKxWixyM",
    index: "waitlist 63",
    credits: 50,
    email: "jacopo.ognibene@netspa.it",
    createdAt: "2024-02-06T08:31:29.915Z",
  },
  {
    id: "9wqzm9AhlccFACbptVMJ",
    index: "waitlist 64",
    credits: 50,
    email: "gest@isaplan.net",
    createdAt: "2024-02-07T09:50:09.796Z",
  },
  {
    id: "2vjbmt5WZxOPzlSN5428",
    index: "waitlist 65",
    credits: 50,
    email: "s.gest@gmx.de",
    createdAt: "2024-02-07T09:51:23.631Z",
  },
  {
    id: "WPvY7fe3l0arTWTa1Xui",
    index: "waitlist 66",
    credits: 50,
    email: "joel.kruber@viakoeln.de",
    createdAt: "2024-02-07T09:51:44.008Z",
  },
  {
    id: "zYbjuYINtJ0zLuG0n0L2",
    index: "waitlist 67",
    credits: 50,
    email: "dieter.schoeffamann@koeln-freiwillig.de",
    createdAt: "2024-02-07T09:52:04.783Z",
  },
  {
    id: "WnB5LEr4wbU0pRkRKiPJ",
    index: "waitlist 68",
    credits: 50,
    email: "mail@raamwerk.de",
    createdAt: "2024-02-07T09:56:10.441Z",
  },
  {
    id: "lmprTav0uMB07cFLR3Uh",
    index: "waitlist 69",
    credits: 50,
    email: "emely.kadlec@stadtraum.com",
    createdAt: "2024-02-07T10:00:26.075Z",
  },
  {
    id: "0nH6siPlsA9JwzK7bTt0",
    index: "waitlist 70",
    credits: 50,
    email: "j.becker@kokonsult.de",
    createdAt: "2024-02-08T12:43:02.739Z",
  },
  {
    id: "orV4SwFF8eXA8zYrJWkU",
    index: "waitlist 71",
    credits: 50,
    email: "brian.fenzi@gmail.com",
    createdAt: "2024-02-08T15:55:49.163Z",
  },
  {
    id: "nVXPyBxcyLFLjf3R9yyG",
    index: "waitlist 72",
    credits: 50,
    email: "niklas.maassen@rapp.ch",
    createdAt: "2024-02-09T08:17:38.893Z",
  },
  {
    id: "wHLzAU3EQnkv2Y8ImQgA",
    index: "waitlist 73",
    credits: 50,
    email: "post@norbertkrause.net",
    createdAt: "2024-02-14T19:53:33.824Z",
  },
  {
    id: "m1dtzfNkdRJgdbep3hRR",
    index: "waitlist 74",
    credits: 50,
    email: "Consigliere.michelemaria.bertani@comune.arcore.mb.it ",
    createdAt: "2024-02-19T16:28:09.489Z",
  },
  {
    id: "iAxp49MDqc789Wp1iWNB",
    index: "waitlist 75",
    credits: 50,
    email: "Kyricx-infected@gmx.de",
    createdAt: "2024-02-20T22:35:13.340Z",
  },
  {
    id: "vW0cYcWTaRfgcGongqaH",
    index: "waitlist 76",
    credits: 50,
    email: "lea@socialter.fr",
    createdAt: "2024-02-21T10:49:44.039Z",
  },
  {
    id: "hu1NoEZGRgot0jsciqI4",
    index: "waitlist 77",
    credits: 50,
    email: "leo@lakaemper.de",
    createdAt: "2024-02-21T13:11:05.098Z",
  },
  {
    id: "Ni64i2NqSUWdQOCzB8cG",
    index: "waitlist 78",
    credits: 50,
    email: "Ticaro@protonmail.com",
    createdAt: "2024-02-22T10:51:59.674Z",
  },
  {
    id: "JwzPlA6ge0HHiXgTWuYB",
    index: "waitlist 79",
    credits: 50,
    email: "elias.sczesny@web.de",
    createdAt: "2024-02-23T08:46:37.693Z",
  },
  {
    id: "nlrbmRdMD1ZiXj2wF6M0",
    index: "waitlist 80",
    credits: 50,
    email: "nudelnwarm@web.de",
    createdAt: "2024-02-23T14:10:17.350Z",
  },
  {
    id: "XhZyuVq9WQQYV5pFwiMO",
    index: "waitlist 81",
    credits: 50,
    email: "maxx_power@gmx.net",
    createdAt: "2024-02-23T23:36:39.224Z",
  },
  {
    id: "XXUCFdpuH5Nmo1kxNQ80",
    index: "waitlist 82",
    credits: 50,
    email: "Alecsyesty@gmail.com",
    createdAt: "2024-02-24T03:51:33.247Z",
  },
  {
    id: "lzVhC56VIsxs7OSyRILw",
    index: "waitlist 83",
    credits: 50,
    email: "patrick@huber.net",
    createdAt: "2024-02-24T11:43:46.947Z",
  },
  {
    id: "a61pGmBLFJi6qMP3cob5",
    index: "waitlist 84",
    credits: 50,
    email: "heiko.bielinski@gmail.com",
    createdAt: "2024-02-26T10:56:36.085Z",
  },
  {
    id: "FtOcnKk99mzG3aW5STLz",
    index: "waitlist 85",
    credits: 50,
    email: "info.jopa@web.de",
    createdAt: "2024-02-26T13:13:59.711Z",
  },
  {
    id: "Lyfj6d6JEWey579aNY1g",
    index: "waitlist 86",
    credits: 50,
    email: "venkteshbhagat@gmail.com",
    createdAt: "2024-02-27T18:53:04.293Z",
  },
  {
    id: "nnKcbqHr2Dd3SeWV12y6",
    index: "waitlist 87",
    credits: 50,
    email: "tassilomorino@hotmail.de",
    createdAt: "2024-02-27T23:35:24.145Z",
  },
  {
    id: "Du2doSLLTHUHQ8DTmQQA",
    index: "waitlist 88",
    credits: 50,
    email: "leotoope@gmail.com",
    createdAt: "2024-02-29T01:40:57.256Z",
  },
  {
    id: "nX9QsnAOX2Af9n0WSVI9",
    index: "waitlist 89",
    credits: 50,
    email: "jazaran1@yahoo.com",
    createdAt: "2024-02-29T08:57:43.069Z",
  },
  {
    id: "2F8AeEHOpk9l1kNdBqe6",
    index: "waitlist 90",
    credits: 50,
    email: "sven.kuder@h-ka.de",
    createdAt: "2024-03-01T08:14:26.649Z",
  },
  {
    id: "mfDKVLEi5j2DV9BU51MD",
    index: "waitlist 91",
    credits: 50,
    email: "yannik.melchior@stpla.karlsruhe.de",
    createdAt: "2024-03-01T08:15:23.209Z",
  },
  {
    id: "2hFBSOrefysUQo5EvR6h",
    index: "waitlist 92",
    credits: 50,
    email: "maskow@hhla.de",
    createdAt: "2024-03-01T08:27:51.691Z",
  },
  {
    id: "1MKmczWb55CRH0OPbiwP",
    index: "waitlist 93",
    credits: 50,
    email: "alexander.fritz@verkehrsingenieure.com",
    createdAt: "2024-03-01T09:22:29.038Z",
  },
  {
    id: "ktZ2FN1WuaJSi6yNQIDr",
    index: "waitlist 94",
    credits: 50,
    email: "chbergius@gmail.com",
    createdAt: "2024-03-01T13:56:56.304Z",
  },
  {
    id: "w7bRx0PoXGYubdeZSg36",
    index: "waitlist 95",
    credits: 50,
    email: "britta_berndt@yahoo.de",
    createdAt: "2024-03-01T17:17:21.713Z",
  },
  {
    id: "HqQ8CNwZ8ZeqP6THKoG2",
    index: "waitlist 96",
    credits: 50,
    email: "robin.woll@citydecks.de",
    createdAt: "2024-03-01T20:51:50.147Z",
  },
  {
    id: "cAVxVbTEItxRtga7Viuf",
    index: "waitlist 97",
    credits: 50,
    email: "Blum@identitaetsstiftung.de",
    createdAt: "2024-03-02T09:28:57.199Z",
  },
  {
    id: "xLmNiYAS3ixqUiLPMPwv",
    index: "waitlist 98",
    credits: 50,
    email: "rontea8@gmail.com",
    createdAt: "2024-03-06T03:11:22.557Z",
  },
  {
    id: "1nWYVhnCiv7d4MQ8tXll",
    index: "waitlist 99",
    credits: 50,
    email: "veedelsfreiraum@gmail.com",
    createdAt: "2024-03-06T15:33:30.722Z",
  },
  {
    id: "Ug0FpxZSwHBKGO7IWRYa",
    index: "waitlist 100",
    credits: 50,
    email: "deniz.ertin@prognos.com",
    createdAt: "2024-03-06T16:21:09.057Z",
  },
  {
    id: "eKOCqv0eerGwXOFo7pvP",
    index: "waitlist 101",
    credits: 50,
    email: "m.ushakov@gmx.de",
    createdAt: "2024-03-07T10:51:08.100Z",
  },
  {
    id: "shSNzjJRMzs1CRozuAkz",
    index: "waitlist 102",
    credits: 50,
    email: "Sohaider@gmail.com",
    createdAt: "2024-03-08T05:47:18.024Z",
  },
  {
    id: "DHPCmtEmiMX20t3LkSL2",
    index: "waitlist 103",
    credits: 50,
    email: "jason.s.williams@outlook.com",
    createdAt: "2024-03-08T14:38:48.984Z",
  },
  {
    id: "TFzTVRbSe2DtaTPiO5xh",
    index: "waitlist 104",
    credits: 50,
    email: "henriette.naerger@ts.berlin",
    createdAt: "2024-03-13T16:35:24.850Z",
  },
  {
    id: "McVPfb8Kd8oebc0vocTd",
    index: "waitlist 105",
    credits: 50,
    email: "william.andersen0@gmail.com",
    createdAt: "2024-03-14T12:12:56.509Z",
  },
  {
    id: "pTE52c17926FGONwYCXG",
    index: "waitlist 106",
    credits: 50,
    email: "Jonathan.Seim@stadt.wuppertal.de",
    createdAt: "2024-03-15T06:51:18.878Z",
  },
  {
    id: "vMxrVoJ6RTRe8cTVLhuP",
    index: "waitlist 107",
    credits: 50,
    email: "car2tree.stuttgart@gmail.com",
    createdAt: "2024-03-15T11:47:05.329Z",
  },
  {
    id: "U9CF4pk5twsxqElBBcKh",
    index: "waitlist 108",
    credits: 50,
    email: "heiko.bielinski@gmail.com",
    createdAt: "2024-03-15T15:26:39.470Z",
  },
  {
    id: "I9dBQIJy1BsVnULPuFiN",
    index: "waitlist 109",
    credits: 50,
    email: "neonsnapper@web.de",
    createdAt: "2024-03-18T10:53:44.557Z",
  },
  {
    id: "qo7Wm6Q5zMmQv6yN7g1T",
    index: "waitlist 110",
    credits: 50,
    email: "post@e-thieme.de",
    createdAt: "2024-03-18T15:34:51.998Z",
  },
  {
    id: "1xf3zBtlEsrXs04kASGH",
    index: "waitlist 111",
    credits: 50,
    email: "veedelsfreiraum@gmail.com",
    createdAt: "2024-03-18T16:02:27.387Z",
  },
  {
    id: "wd3cXV2HGsZ3zFopXjai",
    index: "waitlist 112",
    credits: 50,
    email: "mneff@thurweb.ch",
    createdAt: "2024-03-20T08:12:31.602Z",
  },
  {
    id: "jWDTRu1pImHW0MHZT8Lg",
    index: "waitlist 113",
    credits: 50,
    email: "raffael.fischer@rapp.ch",
    createdAt: "2024-03-21T08:51:19.715Z",
  },
  {
    id: "y0VTIAfrVXOpKwSP2zJl",
    index: "waitlist 114",
    credits: 50,
    email: "nina.schweizer@rapp.ch",
    createdAt: "2024-03-26T08:55:28.394Z",
  },
  {
    id: "C1BLNASaQdNgp2kmJzYm",
    index: "waitlist 115",
    credits: 50,
    email: "mailkati@gmx.at",
    createdAt: "2024-03-26T12:13:03.984Z",
  },
  {
    id: "ecnW3wl0v4Z9F3h2nPEU",
    index: "waitlist 116",
    credits: 50,
    email: "paul.wehner@stadt-koeln.de",
    createdAt: "2024-03-28T09:06:47.956Z",
  },
  {
    id: "NYr2y0jTwJESN8aPqvSX",
    index: "waitlist 117",
    credits: 50,
    email: "dominik.toennes@viakoeln.de",
    createdAt: "2024-03-29T07:26:55.903Z",
  },
  {
    id: "bsOKJ1lDc36SWjemS6Vr",
    index: "waitlist 118",
    credits: 50,
    email: "splatz@landmarken.de",
    createdAt: "2024-04-02T14:31:15.735Z",
  },
  {
    id: "44HIHtOKnju8KEXhGDLG",
    index: "waitlist 119",
    credits: 50,
    email: "veedelsfreiraum@gmail.com",
    createdAt: "2024-04-03T09:03:52.225Z",
  },
  {
    id: "0F4Nf2kAW2YkSFQP60fQ",
    index: "waitlist 120",
    credits: 50,
    email: "christian.mathieu@hotmail.de",
    createdAt: "2024-04-05T18:53:41.595Z",
  },
  {
    id: "S8CpLSPF1AVcB9d93Sc8",
    index: "waitlist 121",
    credits: 50,
    email: "damian.boll@schwaebischhall.de",
    createdAt: "2024-04-08T06:12:24.007Z",
  },
  {
    id: "CueeSMYaUtHd7mmCnvwV",
    index: "waitlist 122",
    credits: 50,
    email: "damian.boll@schwaebischhall.de",
    createdAt: "2024-04-09T11:26:02.853Z",
  },
  {
    id: "8oEqtux3OBzsMje9wzVa",
    index: "waitlist 123",
    credits: 50,
    email: "martin.widdig@gmail.com",
    createdAt: "2024-04-11T14:53:35.515Z",
  },
  {
    id: "1MO8RXMNGnSXNWBN8Tg7",
    index: "waitlist 124",
    credits: 50,
    email: "me_woe@yahoo.com",
    createdAt: "2024-04-12T06:12:23.136Z",
  },
  {
    id: "uaG4DqBdgDT6Vnl1nWxn",
    index: "waitlist 125",
    credits: 50,
    email: "henryvillacis362@gmail.com",
    createdAt: "2024-04-12T07:35:24.044Z",
  },
  {
    id: "qT5FjYB7OqtLJdllGKCm",
    index: "waitlist 126",
    credits: 50,
    email: "arodriguezpalmeiro@gmail.com",
    createdAt: "2024-04-12T08:28:19.013Z",
  },
  {
    id: "9inxA9iNEVMrSSYuTTdc",
    index: "waitlist 127",
    credits: 50,
    email: "info@cynthiaechave.com",
    createdAt: "2024-04-12T08:41:26.525Z",
  },
  {
    id: "gxR9QdQy7po1YIOqKq1D",
    index: "waitlist 128",
    credits: 50,
    email: "jfont@cinesi.es",
    createdAt: "2024-04-12T09:34:03.508Z",
  },
  {
    id: "s9Zp75fAIgNg36Q6hpa6",
    index: "waitlist 129",
    credits: 50,
    email: "xcodina@gmail.com",
    createdAt: "2024-04-12T09:44:59.453Z",
  },
  {
    id: "iK93KOTyfXR9g1NA0E2q",
    index: "waitlist 130",
    credits: 50,
    email: "camilo@arrenberg.studio",
    createdAt: "2024-04-12T13:13:34.028Z",
  },
  {
    id: "vMss9oyASeJ5NBMVZext",
    index: "waitlist 131",
    credits: 50,
    email: "roger@tandemprojects.cat",
    createdAt: "2024-04-12T15:16:33.738Z",
  },
  {
    id: "1x9Qsv1XvdRJtd8dQhRL",
    index: "waitlist 132",
    credits: 50,
    email: "Info@pezestudio.org",
    createdAt: "2024-04-12T22:15:15.295Z",
  },
  {
    id: "li1AhUi3zEN7wAHRk16a",
    index: "waitlist 133",
    credits: 50,
    email: "joao.miguel1502@gmail.com",
    createdAt: "2024-04-13T14:37:59.519Z",
  },
  {
    id: "ibDywFpipaNyMWN1I3Mv",
    index: "waitlist 134",
    credits: 50,
    email: "ablanchbou@gmail.com",
    createdAt: "2024-04-14T09:07:32.127Z",
  },
  {
    id: "ghas5D7vqewAYPkOWIhX",
    index: "waitlist 135",
    credits: 50,
    email: "xcodina@gmail.com",
    createdAt: "2024-04-14T15:03:14.060Z",
  },
  {
    id: "C4HbBfrKWrxOKl0iumy7",
    index: "waitlist 136",
    credits: 50,
    email: "andreu.blanch@smbalenya.cat",
    createdAt: "2024-04-15T06:06:50.307Z",
  },
  {
    id: "Enqan0S7GU4hguxIVBJ9",
    index: "waitlist 137",
    credits: 50,
    email: "mguevara@ersilia.org",
    createdAt: "2024-04-15T09:24:06.685Z",
  },
  {
    id: "OO1jpZEWkUOOjloCF89g",
    index: "waitlist 138",
    credits: 50,
    email: "Jonathan.Seim@stadt.wuppertal.de",
    createdAt: "2024-04-15T13:56:48.808Z",
  },
  {
    id: "qkI6pDIUGI4PBoYMtqb3",
    index: "waitlist 139",
    credits: 50,
    email: "xavierblazquez@gencat.cat",
    createdAt: "2024-04-16T06:28:25.099Z",
  },
  {
    id: "q0PgNlwPwAse2YuAjpFj",
    index: "waitlist 140",
    credits: 50,
    email: "schroeder-dickreuter@planersocietaet.de",
    createdAt: "2024-04-16T07:11:55.945Z",
  },
  {
    id: "gEmhVIYQQgSEkCDnVrVs",
    index: "waitlist 141",
    credits: 50,
    email: "incertesa@gmail.com",
    createdAt: "2024-04-17T08:44:06.637Z",
  },
  {
    id: "cwq0t7erz4fM6GPUcj1A",
    index: "waitlist 142",
    credits: 50,
    email: "ninatsuts@gmail.com",
    createdAt: "2024-04-17T22:03:29.557Z",
  },
  {
    id: "tTbDBAcRZnMH2LbRSUeB",
    index: "waitlist 143",
    credits: 50,
    email: "agnes.etzbach@viakoeln.de",
    createdAt: "2024-04-18T09:15:21.248Z",
  },
  {
    id: "NUQE5ZnFPK7TCb7a75eG",
    index: "waitlist 144",
    credits: 50,
    email: "Ackermann@urbanista.de",
    createdAt: "2024-04-18T09:15:57.125Z",
  },
  {
    id: "SVCRrD3dSnaYOwGXOVz5",
    index: "waitlist 145",
    credits: 50,
    email: "weseloh@gruppef.com",
    createdAt: "2024-04-18T09:16:11.248Z",
  },
  {
    id: "WaPjMQPDNUEI3z3C1OBL",
    index: "waitlist 146",
    credits: 50,
    email: "vitofeina@gmail.com",
    createdAt: "2024-04-18T15:44:13.788Z",
  },
  {
    id: "CxbljGVYTxvYdKdW3Ae3",
    index: "waitlist 147",
    credits: 50,
    email: "gerard.bv@gmail.com",
    createdAt: "2024-04-19T08:07:31.048Z",
  },
  {
    id: "eEoCyeJhTJ3nCOBtghuo",
    index: "waitlist 148",
    credits: 50,
    email: "ana@juntura.eus",
    createdAt: "2024-04-19T14:36:48.917Z",
  },
  {
    id: "mIznQ6YUH2eJT67hLmYf",
    index: "waitlist 149",
    credits: 50,
    email: "lbrodolini@gransolarghella.com",
    createdAt: "2024-04-20T12:45:39.707Z",
  },
  {
    id: "5Qu11YNZnPEhm9eKjzVa",
    index: "waitlist 150",
    credits: 50,
    email: "mistrettacecilia@gmail.com",
    createdAt: "2024-04-21T22:36:40.014Z",
  },
  {
    id: "xqf4yqKxXC4FQQygWVTA",
    index: "waitlist 151",
    credits: 50,
    email: "mistrettacecilia@gmail.com",
    createdAt: "2024-04-21T22:37:45.247Z",
  },
  {
    id: "6rHoH2V9m24JGSFk4wnv",
    index: "waitlist 152",
    credits: 50,
    email: "Lisa.heilmann@ifok.de",
    createdAt: "2024-04-22T07:43:08.528Z",
  },
  {
    id: "pgpvNLsbRWeJLLi2w7RL",
    index: "waitlist 153",
    credits: 50,
    email: "Ana_rp3@hotmail.com",
    createdAt: "2024-04-22T14:52:34.941Z",
  },
  {
    id: "omJSgt3XRDJiVJg9L54F",
    index: "waitlist 154",
    credits: 50,
    email: "guzmancalso@hotmail.com",
    createdAt: "2024-04-22T15:10:36.379Z",
  },
  {
    id: "fbhsFtGOryqcc31M2rlq",
    index: "waitlist 155",
    credits: 50,
    email: "annapalmira.crescenza@student.unisg.ch",
    createdAt: "2024-04-23T13:19:03.312Z",
  },
  {
    id: "WHe3Y8DOlmK5EzAH7WyP",
    index: "waitlist 156",
    credits: 50,
    email: "a.oraiopoulos@ucl.ac.uk",
    createdAt: "2024-04-25T08:37:23.501Z",
  },
  {
    id: "MaaspIZtx7Z5PenTIkL3",
    index: "waitlist 157",
    credits: 50,
    email: "konstantinos.kourkoutas@uab.cat",
    createdAt: "2024-04-25T09:14:13.231Z",
  },
  {
    id: "HJOJsiNRRIJGjMuLpcOX",
    index: "waitlist 158",
    credits: 50,
    email: "joscha.fuhrmann@stadt-koeln.de",
    createdAt: "2024-04-26T13:42:11.393Z",
  },
  {
    id: "uULIsbhWMwYjsDUVhqZ5",
    index: "waitlist 159",
    credits: 50,
    email: "xcodina@gmail.com",
    createdAt: "2024-04-29T07:46:08.235Z",
  },
  {
    id: "nBv7VQK7cRuEskT94t3y",
    index: "waitlist 160",
    credits: 50,
    email: "xavier.codina@anthesisgroup.com",
    createdAt: "2024-04-29T08:00:19.436Z",
  },
  {
    id: "XipFbC6u14MtLTPOx0GB",
    index: "waitlist 161",
    credits: 50,
    email: "bakake2153@togito.com",
    createdAt: "2024-04-29T08:22:43.444Z",
  },
  {
    id: "UIvtkVTY2VmC0gX8a8jh",
    index: "waitlist 162",
    credits: 50,
    email: "frederik.moellers@stadt-koeln.de",
    createdAt: "2024-05-07T07:57:58.933Z",
  },
  {
    id: "5ONUsybzFtBaX8gMuM4H",
    index: "waitlist 163",
    credits: 50,
    email: "tobias.rehm@climateconnect.earth",
    createdAt: "2024-05-08T11:40:15.477Z",
  },
  {
    id: "RXEsN3GV9fVdYBlBCSsO",
    index: "waitlist 164",
    credits: 50,
    email: "info@ralfbrand.com",
    createdAt: "2024-05-11T20:47:23.478Z",
  },
  {
    id: "NfytVAhGZmmpXMN3KJgz",
    index: "waitlist 165",
    credits: 50,
    email: "martins@viadukt.de",
    createdAt: "2024-05-14T10:01:59.758Z",
  },
  {
    id: "99siqJvTrENwDgPAVT87",
    index: "waitlist 166",
    credits: 50,
    email: "mariapb365@gmail.com",
    createdAt: "2024-05-15T12:46:43.980Z",
  },
  {
    id: "XpElPqoDGS6Vy9E0933c",
    index: "waitlist 167",
    credits: 50,
    email: "Juan.alg88gmail.com",
    createdAt: "2024-05-15T17:05:45.181Z",
  },
  {
    id: "0KkaQ7TZANo7HFF0pdJ7",
    index: "waitlist 168",
    credits: 50,
    email: "tatiana.oliveira.pm@gmail.com",
    createdAt: "2024-05-16T15:08:45.360Z",
  },
  {
    id: "eiH9gsEwGkco4ZP5c0Cr",
    index: "waitlist 169",
    credits: 50,
    email: "pierre.helwig@gmail.com",
    createdAt: "2024-05-17T07:58:43.665Z",
  },
  {
    id: "ZC88rxu5jMlSUwPijNbS",
    index: "waitlist 170",
    credits: 50,
    email: "herr.bredemeyer@gmail.com",
    createdAt: "2024-05-17T12:42:02.460Z",
  },
  {
    id: "640DpiDfsFZC5fWGrbr6",
    index: "waitlist 171",
    credits: 50,
    email: "herr.bredemeyer@gmail.com",
    createdAt: "2024-05-17T12:43:04.062Z",
  },
  {
    id: "0E0fLFRbx3x2kXdlMSBp",
    index: "waitlist 172",
    credits: 50,
    email: "max.zanartu@racc.es",
    createdAt: "2024-05-17T12:54:00.848Z",
  },
  {
    id: "ta8RnJLa8nnv0Ud30zwt",
    index: "waitlist 173",
    credits: 50,
    email: "eckert@nachhaltigkeitsforum.org",
    createdAt: "2024-05-17T12:54:35.474Z",
  },
  {
    id: "ef25XpyKztdIqgBj401z",
    index: "waitlist 174",
    credits: 50,
    email: "florianders@hotmail.com",
    createdAt: "2024-05-20T07:39:53.291Z",
  },
  {
    id: "JWd8Un6vaWNhlwGHLUCe",
    index: "waitlist 175",
    credits: 50,
    email: "DeFreese.michelle@gmail.com",
    createdAt: "2024-05-20T10:12:55.170Z",
  },
  {
    id: "DKOyxER18no2O6jb6D0T",
    index: "waitlist 176",
    credits: 50,
    email: "dseptien@alberamedioambiente.com",
    createdAt: "2024-05-20T11:46:52.348Z",
  },
  {
    id: "N5NQJsCzsP8UPV2wXYtb",
    index: "waitlist 177",
    credits: 50,
    email: "cerve82@gmail.com",
    createdAt: "2024-05-22T10:43:33.559Z",
  },
  {
    id: "F3d2MuCh8iIqyRVT2NJE",
    index: "waitlist 178",
    credits: 50,
    email: "Francisco.Cerezuela@ecda.co.uk",
    createdAt: "2024-05-22T10:43:50.431Z",
  },
  {
    id: "Z3pXFxMlpFH2HyYiOENG",
    index: "waitlist 179",
    credits: 50,
    email: "thomas@greenovacity.de",
    createdAt: "2024-05-23T07:25:53.086Z",
  },
  {
    id: "phqL9TkpgoRcPgdEQ3bU",
    index: "waitlist 180",
    credits: 50,
    email: "leonard.stenger@verticalparking.de",
    createdAt: "2024-05-23T07:28:33.391Z",
  },
  {
    id: "51nwhdOz3fNFFyamws2K",
    index: "waitlist 181",
    credits: 50,
    email: "herr.bredemeyer@gmail.com",
    createdAt: "2024-05-23T08:10:12.063Z",
  },
  {
    id: "LEMTBwzhY4EFDE0NZqcX",
    index: "waitlist 182",
    credits: 50,
    email: "michaelhreinicke@gmail.com",
    createdAt: "2024-05-23T08:33:48.430Z",
  },
  {
    id: "a1Xh2xtt2JOsnRr4TJfi",
    index: "waitlist 183",
    credits: 50,
    email: "bryarcivil@gmail.com ",
    createdAt: "2024-05-23T13:19:14.673Z",
  },
  {
    id: "y6EZtTU7rpTYdLY76Ros",
    index: "waitlist 184",
    credits: 50,
    email: "andreas.helsper@iao.fraunhofer.de",
    createdAt: "2024-05-23T13:24:21.324Z",
  },
  {
    id: "TvZym6UTYGwjp4v6VZDr",
    index: "waitlist 185",
    credits: 50,
    email: "mwebschae@web.de",
    createdAt: "2024-05-23T14:55:09.663Z",
  },
  {
    id: "unLD21XARbyXTCb42w5B",
    index: "waitlist 186",
    credits: 50,
    email: "alecsandru.miron@gmail.com",
    createdAt: "2024-05-23T17:59:50.040Z",
  },
  {
    id: "6ti5Nn0B2VEzhRj75Vij",
    index: "waitlist 187",
    credits: 50,
    email: "urbanutopia@christianunger.de",
    createdAt: "2024-05-23T18:17:06.712Z",
  },
  {
    id: "s9N6UMvieq5RttHuWSlJ",
    index: "waitlist 188",
    credits: 50,
    email: "Bvanbruggen@gmail.com",
    createdAt: "2024-05-23T20:37:31.272Z",
  },
  {
    id: "EZT7ljo1WuImgKx1oDRB",
    index: "waitlist 189",
    credits: 50,
    email: "e.hasler@bsqb.de",
    createdAt: "2024-05-24T07:46:38.385Z",
  },
  {
    id: "Slg2kOD7PptVdXGxCfp1",
    index: "waitlist 190",
    credits: 50,
    email: "studio@eibenberger.net",
    createdAt: "2024-05-24T08:00:04.841Z",
  },
  {
    id: "7fzaTdWomrTVJcKZWtnL",
    index: "waitlist 191",
    credits: 50,
    email: "losito.stefania.2001@gmail.com",
    createdAt: "2024-05-24T10:19:16.125Z",
  },
  {
    id: "tA86v5k9yuL9O8VVLWyQ",
    index: "waitlist 192",
    credits: 50,
    email: "f.signorella@studenti.poliba.it",
    createdAt: "2024-05-24T14:08:44.671Z",
  },
  {
    id: "2ZdX0gzxgKoxpbrSnkKL",
    index: "waitlist 193",
    credits: 50,
    email: "f.dipaola2@studenti.poliba.it",
    createdAt: "2024-05-24T14:08:51.739Z",
  },
  {
    id: "PdECtqUtW5GIX0z5sDW1",
    index: "waitlist 194",
    credits: 50,
    email: "losito.stefania.2001@gmail.com",
    createdAt: "2024-05-24T14:10:15.312Z",
  },
  {
    id: "8giyvX8O9sEX176tP6IZ",
    index: "waitlist 195",
    credits: 50,
    email: "losito.stefania.2001@gmail.com",
    createdAt: "2024-05-24T14:14:01.740Z",
  },
  {
    id: "4vLf1188KAkTaczhNW2C",
    index: "waitlist 196",
    credits: 50,
    email: "Annette.ritter@luebeck-tourismus.de",
    createdAt: "2024-05-24T17:12:31.701Z",
  },
  {
    id: "tgBMgQVzJLZf8vcrhXAd",
    index: "waitlist 197",
    credits: 50,
    email: "helena.becker14@gmail.com",
    createdAt: "2024-05-25T14:16:59.998Z",
  },
  {
    id: "B634t5SGonveWCLRpwdH",
    index: "waitlist 198",
    credits: 50,
    email: "zarabinifornever@gmail.com",
    createdAt: "2024-05-26T19:46:33.332Z",
  },
  {
    id: "GvggCxHTfBOyDMs5N6q3",
    index: "waitlist 199",
    credits: 50,
    email: "jbarthel4@gmail.com",
    createdAt: "2024-05-27T12:45:50.476Z",
  },
  {
    id: "HUhsAhTLKRo19s8MNcfn",
    index: "waitlist 200",
    credits: 50,
    email: "2000joaonicolas@gmail.com",
    createdAt: "2024-05-29T14:01:47.785Z",
  },
  {
    id: "IUY29vjaUewLyoI66b8n",
    index: "waitlist 201",
    credits: 50,
    email: "adrian.spannagel@vechta.de",
    createdAt: "2024-06-04T09:33:12.307Z",
  },
  {
    id: "kiewGa5JRs1xgYe5FlaC",
    index: "waitlist 202",
    credits: 50,
    email: "adipa.klom@gmail.com",
    createdAt: "2024-06-04T11:45:07.539Z",
  },
  {
    id: "MVaKJ4aG478Jm25pKrsS",
    index: "waitlist 203",
    credits: 50,
    email: "antirolamp@gmail.com",
    createdAt: "2024-06-18T15:42:22.720Z",
  },
  {
    id: "BG3CNCaxGCs0nM06gIrI",
    index: "waitlist 204",
    credits: 50,
    email: "antirolamp@gmail.come",
    createdAt: "2024-06-18T15:45:13.404Z",
  },
  {
    id: "M2fpLEPy1e28t43k6PZg",
    index: "waitlist 205",
    credits: 50,
    email: "leonie.firmenich@stadt-koeln.de",
    createdAt: "2024-06-24T11:02:01.493Z",
  },
  {
    id: "I6Iz5hPQUF4Wf14F3JFt",
    index: "waitlist 206",
    credits: 50,
    email: "carolavegagal@gmail.com",
    createdAt: "2024-06-29T16:29:41.904Z",
  },
  {
    id: "P2d0d12X1W487ce3HJ2x",
    index: "waitlist 207",
    credits: 50,
    email: "rachel@newforestescapes.com",
    createdAt: "2024-07-01T20:42:33.791Z",
  },
  {
    id: "OJMDWwBQIaMFj9bdNfTY",
    index: "waitlist 208",
    credits: 50,
    email: "mickra@web.de",
    createdAt: "2024-07-03T06:58:54.488Z",
  },
  {
    id: "tpcjy3Z0MoTyvokafope",
    index: "waitlist 209",
    credits: 50,
    email: "ibq60022@ilebi.com",
    createdAt: "2024-07-03T11:11:18.851Z",
  },
  {
    id: "VD0vGx0sQoGtKcmVkdZQ",
    index: "waitlist 210",
    credits: 50,
    email: "christian.dworatzek@fh-erfurt.de",
    createdAt: "2024-07-05T09:36:29.725Z",
  },
  {
    id: "AaUT3yXFJVTXFlMo027U",
    index: "waitlist 211",
    credits: 50,
    email: "akoer.team@outlook.com",
    createdAt: "2024-07-05T11:58:57.332Z",
  },
  {
    id: "B8Ja3ODLUaHmccy9QtHO",
    index: "waitlist 212",
    credits: 50,
    email: "david.abel@stadt.wuppertal.de",
    createdAt: "2024-07-05T11:59:45.720Z",
  },
  {
    id: "KuKSWUFbXMBMk8MnnKIz",
    index: "waitlist 213",
    credits: 50,
    email: "akazienkiez@kiezblocks.de",
    createdAt: "2024-07-06T09:37:31.603Z",
  },
  {
    id: "AuRzeRL00kPSAUm2LxgB",
    index: "waitlist 214",
    credits: 50,
    email: "Nuri.fa@yahoo.com",
    createdAt: "2024-07-06T16:23:11.087Z",
  },

  {
    id: "GpTp8ajtJIrsBtzGtfyX",
    index: "newcodes 2",
    credits: 50,
  },
  {
    id: "1cLTNkW22aJ0Dj9AlkWv",
    index: "newcodes 3",
    credits: 50,
  },
  {
    id: "hPIgl0ismrYK0dltt6ZS",
    index: "newcodes 4",
    credits: 50,
  },
  {
    id: "8DZMtpkhqnOu43uE6Wp6",
    index: "newcodes 5",
    credits: 50,
  },
  {
    id: "Nru081mYGfnVV2yesy3w",
    index: "newcodes 6",
    credits: 50,
  },
  {
    id: "obPG9wkKCzxRhO0Xsqyp",
    index: "newcodes 7",
    credits: 50,
  },
  {
    id: "d3GPDiSZEvKrPrPanVId",
    index: "newcodes 8",
    credits: 50,
  },
  {
    id: "ZDSRJkAb2QMIzQa2JuxY",
    index: "newcodes 9",
    credits: 50,
  },
  {
    id: "jDJTPjOMajnuYslhEhyX",
    index: "newcodes 10",
    credits: 50,
  },
  {
    id: "0LPKw5gPliPuVeLn2ZJD",
    index: "newcodes 11",
    credits: 50,
  },
  {
    id: "bPIMNWNzS2XLNIY2X8t6",
    index: "newcodes 12",
    credits: 50,
  },
  {
    id: "mBC5ZjcUe37OUwIPyc1q",
    index: "newcodes 13",
    credits: 50,
  },
  {
    id: "5f8Jpo4PFw5YSK67fhZn",
    index: "newcodes 14",
    credits: 50,
  },
  {
    id: "sCuPybpUk37Ur8zcHASu",
    index: "newcodes 15",
    credits: 50,
  },
  {
    id: "Z6FkZTPI7VLHN3RzkK1n",
    index: "newcodes 16",
    credits: 50,
  },
  {
    id: "eatKLtSlBQp3zMSWD8ov",
    index: "newcodes 17",
    credits: 50,
  },
  {
    id: "bQiqy6Ve2kLAXPuDhb4v",
    index: "newcodes 18",
    credits: 50,
  },
  {
    id: "dgMELOvNEeWG3pO5vaPy",
    index: "newcodes 19",
    credits: 50,
  },
  {
    id: "gR1c6TMtzhbkMvUzS5Rk",
    index: "newcodes 20",
    credits: 50,
  },
  {
    id: "uQvP7rigBV3cwTniDPio",
    index: "newcodes 21",
    credits: 50,
  },
  {
    id: "uVMmy7AvjGyf6EE0snIx",
    index: "newcodes 22",
    credits: 50,
  },
  {
    id: "gUOb8NMeuF4YhQSHrmq9",
    index: "newcodes 23",
    credits: 50,
  },
  {
    id: "xqKbckzR1mAwCNzHIo3J",
    index: "newcodes 24",
    credits: 50,
  },
  {
    id: "ZJPtIQg2N7KHnNJGCb8v",
    index: "newcodes 25",
    credits: 50,
  },
  {
    id: "skB4KVuRAxdePEtIeVLp",
    index: "newcodes 26",
    credits: 50,
  },
  {
    id: "1S2bRmZuRwJp4o19W0sb",
    index: "newcodes 27",
    credits: 50,
  },
  {
    id: "P1t8H8tRljg3JvPnEmyc",
    index: "newcodes 28",
    credits: 50,
  },
  {
    id: "81JYsf3lhkEYMrGrw31T",
    index: "newcodes 29",
    credits: 50,
  },
  {
    id: "5rb62sLnSVOWADvrTubj",
    index: "newcodes 30",
    credits: 50,
  },
  {
    id: "RzLpZxllB6XUuFFcn6l2",
    index: "newcodes 31",
    credits: 250,
  },
  {
    id: "B9emtY8bXIhX5oDMK6ki",
    index: "newcodes 32",
    credits: 50,
  },
  {
    id: "DUSxoAcfGTdL9nptvxC2",
    index: "newcodes 33",
    credits: 50,
  },
  {
    id: "N0edbC8w5UWH0Q3D7DIa",
    index: "newcodes 34",
    credits: 50,
  },
  {
    id: "6KIYV6MvyNVsyd6T3JUk",
    index: "newcodes 35",
    credits: 50,
  },
  {
    id: "MFBxxdFBlg9mEmGdo0to",
    index: "newcodes 36",
    credits: 50,
  },
  {
    id: "dncikHmF8jCqyfq2IGIk",
    index: "newcodes 37",
    credits: 50,
  },
  {
    id: "RZLIqBtel1KCrtneJCS1",
    index: "newcodes 38",
    credits: 50,
  },
  {
    id: "uu1iLmNQlQiFDKYiGtmZ",
    index: "newcodes 39",
    credits: 50,
  },
  {
    id: "PTVNeEWrtYBJ8rPrXMib",
    index: "newcodes 40",
    credits: 50,
  },
  {
    id: "tTjP1EX9U5OayLXjJZ9T",
    index: "newcodes 41",
    credits: 50,
  },
  {
    id: "HsXGe7E4oKeVKGeoQRCb",
    index: "newcodes 42",
    credits: 50,
  },
  {
    id: "L9aZGcXVv6LhgYztRbgO",
    index: "newcodes 43",
    credits: 50,
  },
  {
    id: "2BvYhgJYSTZCrT6tMWSo",
    index: "newcodes 44",
    credits: 50,
  },
  {
    id: "miszw43r9uoSPaDiMFVV",
    index: "newcodes 45",
    credits: 50,
  },
  {
    id: "eko9HMvMGnFT4mYsMYaW",
    index: "newcodes 46",
    credits: 50,
  },
  {
    id: "YhsF9l6PJEHckCk7Eh7R",
    index: "newcodes 47",
    credits: 50,
  },
  {
    id: "WUcidBEc5AG8d2W3bcP2",
    index: "newcodes 48",
    credits: 50,
  },
  {
    id: "yeNmZacQFMHUgijJeTV9",
    index: "newcodes 49",
    credits: 50,
  },
  {
    id: "V6uC6jLJnDo6txAV13MN",
    index: "newcodes 50",
    credits: 50,
  },
  {
    id: "zmwBncaLPpKykQLa6vMD",
    index: "newcodes 51",
    credits: 50,
  },
  {
    id: "oEJzqHhVw6Dsidtwof7J",
    index: "newcodes 52",
    credits: 50,
  },
  {
    id: "UENq9Dr4Tq43jBauX3g9",
    index: "newcodes 53",
    credits: 50,
  },
  {
    id: "qkJSi5wYMNLGg5ukT9J6",
    index: "newcodes 54",
    credits: 50,
  },
  {
    id: "gmrykBxEIwer7gBZmwtn",
    index: "newcodes 55",
    credits: 50,
  },
  {
    id: "K7FY4T6WcRMgagSS1n7u",
    index: "newcodes 56",
    credits: 50,
  },
  {
    id: "ApWRc1KmGZ8ttuaOwnoX",
    index: "newcodes 57",
    credits: 50,
  },
  {
    id: "gZiqbMSt6B3PvGOQSoVB",
    index: "newcodes 58",
    credits: 50,
  },
  {
    id: "C0zoCo70kFgprSVwwRS2",
    index: "newcodes 59",
    credits: 50,
  },
  {
    id: "Bmkll0f0W8QaHPJtk1lX",
    index: "newcodes 60",
    credits: 50,
  },
  {
    id: "nLy99Wyz4wEZjX0KU4PR",
    index: "newcodes 61",
    credits: 50,
  },
  {
    id: "TNlCLGfCqebQsbuUCywF",
    index: "newcodes 62",
    credits: 50,
  },
  {
    id: "hotg83XpPe50lDhBsfZS",
    index: "newcodes 63",
    credits: 50,
  },
  {
    id: "v76pfDoIdd66GhdKRg3G",
    index: "newcodes 64",
    credits: 50,
  },
  {
    id: "xbmNlpHzilAm7Qfsd12i",
    index: "newcodes 65",

    credits: 50,
  },
  {
    id: "lg7vw6IHS71QqMKdvQfn",
    index: "newcodes 66",
    credits: 50,
  },
  {
    id: "JNE2Zq0kTyLuNFTyvGNQ",
    index: "newcodes 67",
    credits: 50,
  },
  {
    id: "BL3NW5DzOyLhgbIgd21N",
    index: "newcodes 68",
    credits: 50,
  },
  {
    id: "ru67VTWtMz3bXzwpFOu0",
    index: "newcodes 69",
    credits: 50,
  },
  {
    id: "aTgkLOjH0LSazU8W0LdB",
    index: "newcodes 70",
    credits: 50,
  },
  {
    id: "OpAZU3sctTYXXACwHLGO",
    index: "newcodes 71",
    credits: 50,
  },
  {
    id: "i61MIftlwzwD6onNKzuo",
    index: "newcodes 72",
    credits: 50,
  },
  {
    id: "ZZnPQgyIfFksWOlk63JI",
    index: "newcodes 73",
    credits: 50,
  },
  {
    id: "WKTZwhSfkGgfwBgYQMwL",
    index: "newcodes 74",
    credits: 50,
  },
  {
    id: "MavX4v57SzmJNZz0gauv",
    index: "newcodes 75",
    credits: 50,
  },
  {
    id: "xRqB7bmvAa1143L4FOpy",
    index: "newcodes 76",
    credits: 50,
  },
  {
    id: "dImK1RWcm3iKUVVtYsoG",
    index: "newcodes 77",
    credits: 50,
  },
  {
    id: "uCXOX9fu9G7pVaiFoUAX",
    index: "newcodes 78",
    credits: 50,
  },
  {
    id: "KSNyaNjhzSCzdm2eAh39",
    index: "newcodes 79",
    credits: 50,
  },
  {
    id: "7fR7Fljcn0LKD8fSpsv0",
    index: "newcodes 80",
    credits: 50,
  },
  {
    id: "e5tAegWL7fCbqymVj9GP",
    index: "newcodes 81",
    credits: 50,
  },
  {
    id: "lVQObqYiAdB4TU8HXog8",
    index: "newcodes 82",
    credits: 50,
  },
  {
    id: "pd4JevdRZ5uAEUrGWfXQ",
    index: "newcodes 83",
    credits: 50,
  },
  {
    id: "X8n53GR024f7vpAgxQk4",
    index: "newcodes 84",
    credits: 50,
  },
  {
    id: "2IUQvJBedAC3OgyXWj72",
    index: "newcodes 85",
    credits: 50,
  },
  {
    id: "BF9FnTx7271WSOFgN8t2",
    index: "newcodes 86",
    credits: 50,
  },
  {
    id: "uOhUoGykq999RfNGu7YC",
    index: "newcodes 87",
    credits: 50,
  },
  {
    id: "znA7kw8HyFfAOyYZACiH",
    index: "newcodes 88",
    credits: 50,
  },
  {
    id: "ESZwLbX2P5zF4vzStRGh",
    index: "newcodes 89",
    credits: 50,
  },
  {
    id: "SajoBT6YfBrG1QlLIOmj",
    index: "newcodes 90",
    credits: 50,
  },
  {
    id: "L4Xgj8My6Gdu1U7TzvJe",
    index: "newcodes 91",
    credits: 50,
  },
  {
    id: "93hfTJIipTQPjwMNeFZp",
    index: "newcodes 92",
    credits: 50,
  },
  {
    id: "98rkJoYYtAHhJ6lkrYVk",
    index: "newcodes 93",
    credits: 50,
  },
  {
    id: "fQFhCgZvoZuulgmU9uHJ",
    index: "newcodes 94",
    credits: 50,
  },
  {
    id: "EMUp8FxmDjmyk7YaM1ti",
    index: "newcodes 95",
    credits: 50,
  },
  {
    id: "grfEvntbn1cxqlAqfqXy",
    index: "newcodes 96",
    credits: 50,
  },
  {
    id: "379D0JLF3qVZ4KvHnO9C",
    index: "newcodes 97",
    credits: 50,
  },
  {
    id: "Sc97v6EOGGFm6Zgy9fXf",
    index: "newcodes 98",
    credits: 50,
  },
  {
    id: "YJRtS8BnZpourhj4nL2c",
    index: "newcodes 99",
    credits: 50,
  },
  {
    id: "q7YSMzbjn7vROOjWDUWX",
    index: "newcodes 100",
    credits: 10000,
  },
  {
    id: "4QhpxxurUSmNPVl4Q6ww",
    index: "newcodes 101",
    credits: 50,
  },
  {
    id: "wRNE3ZJ8fwVfQyuDaL1U",
    index: "newcodes 102",
    credits: 50,
  },
  {
    id: "jA9UC16FTpFwMoeavDfH",
    index: "newcodes 103",

    credits: 50,
  },
  {
    id: "3VDAnZ8hFrl3Nreh589V",
    index: "newcodes 104",

    credits: 50,
  },
  {
    id: "L0FZTwfTfCa03pF9Tc6Z",
    index: "newcodes 105",

    credits: 50,
  },
  {
    id: "g5pptkfnDmIwICE2RH3k",
    index: "newcodes 106",

    credits: 50,
  },
  {
    id: "EYST4mElRwn0cmRlOpiW",
    index: "newcodes 107",

    credits: 50,
  },
  {
    id: "BdVPsBt3OmbixIIBFhsF",
    index: "newcodes 108",

    credits: 50,
  },
  {
    id: "pwrhATgyr7RA4VjgrVuW",
    index: "newcodes 109",

    credits: 50,
  },
  {
    id: "ljEbnaV5KbJnkjmJngYj",
    index: "newcodes 110",

    credits: 50,
  },
  {
    id: "z8DYb6k81NzIBnl4wop0",
    index: "newcodes 111",

    credits: 50,
  },
  {
    id: "mjAtVBon4LsRdTiyEgxu",
    index: "newcodes 112",

    credits: 50,
  },
  {
    id: "HeeW9Lujo9cTE4gz3RUe",
    index: "newcodes 113",

    credits: 50,
  },
  {
    id: "NclJU7cKQXExEcgp5WNc",
    index: "newcodes 114",

    credits: 50,
  },
  {
    id: "8lXACds78k6NnfFsdgkp",
    index: "newcodes 115",

    credits: 50,
  },
  {
    id: "wTkctcitDqSQtuyviAwV",
    index: "newcodes 116",

    credits: 50,
  },
  {
    id: "7HNQ19kvzlqVH3UaBxkl",
    index: "newcodes 117",

    credits: 50,
  },
  {
    id: "F55RtZu4lsoerdXK9vru",
    index: "newcodes 118",

    credits: 50,
  },
  {
    id: "77ltVgtjl9kAVzQQNvtv",
    index: "newcodes 119",

    credits: 50,
  },
  {
    id: "VzERArFdsTJxSTqCuG8E",
    index: "newcodes 120",

    credits: 50,
  },
  {
    id: "85daqEV20wPFd1Jwhm8m",
    index: "newcodes 121",

    credits: 50,
  },
  {
    id: "pvbnJD3CuSooCysNcI2z",
    index: "newcodes 122",

    credits: 50,
  },
  {
    id: "Q54SQNnyO5JsLvFegPu0",
    index: "newcodes 123",

    credits: 50,
  },
  {
    id: "mnta1SqpNODkbL87v7YT",
    index: "newcodes 124",

    credits: 50,
  },
  {
    id: "QOKqTaWmep2ZGnpZXsIf",
    index: "newcodes 125",

    credits: 50,
  },
  {
    id: "9Gfhu8CevjVW8znHQU9K",
    index: "newcodes 126",

    credits: 50,
  },
  {
    id: "czh4DqFVKFGPcsOLEUKM",
    index: "newcodes 127",

    credits: 50,
  },
  {
    id: "Wo07jWs8sH4MH0xaEmfx",
    index: "newcodes 128",

    credits: 50,
  },
  {
    id: "vaQg59ExecSyyR5iS1dh",
    index: "newcodes 129",

    credits: 50,
  },
  {
    id: "RDNl68on36OilimFLl8x",
    index: "newcodes 130",

    credits: 50,
  },
  {
    id: "BhVjm06s2J90g0u0PxHY",
    index: "newcodes 131",

    credits: 50,
  },
  {
    id: "u3kXCtJvJkj1hKHPwmIa",
    index: "newcodes 132",

    credits: 50,
  },
  {
    id: "8Fxbk4NBPCkW21Sx99L2",
    index: "newcodes 133",

    credits: 50,
  },
  {
    id: "r253dlUJrCBLsrGbYvIw",
    index: "newcodes 134",

    credits: 50,
  },
  {
    id: "pPIOjtPK6ZWOAo37cVqn",
    index: "newcodes 135",

    credits: 50,
  },
  {
    id: "IBvpnMquFe788x1Ljzxq",
    index: "newcodes 136",

    credits: 50,
  },
  {
    id: "LwoqTe702XzcUnh9BV3T",
    index: "newcodes 137",

    credits: 50,
  },
  {
    id: "XdB9SxEPOrxpmgListuI",
    index: "newcodes 138",

    credits: 50,
  },
  {
    id: "YFnKLUrnTocbBgRTKh6k",
    index: "newcodes 139",

    credits: 50,
  },
  {
    id: "ZixwDUBSCTmqYTA4CwCs",
    index: "newcodes 140",

    credits: 50,
  },
  {
    id: "nbpEjAxqzDxMgO4ZJY2H",
    index: "newcodes 141",

    credits: 50,
  },
  {
    id: "DxnEF1DPZLtdnA4W6WQY",
    index: "newcodes 142",

    credits: 50,
  },
  {
    id: "Rz2zMM4yBB1vnJZj0Ufi",
    index: "newcodes 143",

    credits: 50,
  },
  {
    id: "LGGmFkSLI30IB4WuCJvh",
    index: "newcodes 144",

    credits: 50,
  },
  {
    id: "yBNncJtnHN56ARDejLF1",
    index: "newcodes 145",

    credits: 50,
  },
  {
    id: "pJWubIhyw6CxCrkP8zlL",
    index: "newcodes 146",

    credits: 50,
  },
  {
    id: "J5PDwxXKiGyWBGoJIkgD",
    index: "newcodes 147",

    credits: 50,
  },
  {
    id: "M0E7VTR1w3EVGTVh1M4k",
    index: "newcodes 148",

    credits: 50,
  },
  {
    id: "vEDFFSDRuNCkG5pYmIvR",
    index: "newcodes 149",

    credits: 50,
  },
  {
    id: "NQukQE3BHLVbm2Kxrz4q",
    index: "newcodes 150",

    credits: 50,
  },
  {
    id: "b3U98v1GrfLLgfu2thOp",
    index: "newcodes 151",

    credits: 50,
  },
  {
    id: "ZATIP8HP18PscKXbcrlt",
    index: "newcodes 152",

    credits: 50,
  },
  {
    id: "HMXFuZGYniGu62UYbwau",
    index: "newcodes 153",

    credits: 50,
  },
  {
    id: "hJrFsPVdJinmNpPIFuPx",
    index: "newcodes 154",

    credits: 50,
  },
  {
    id: "mxyWbF7VYaGv63AdRuIG",
    index: "newcodes 155",

    credits: 50,
  },
  {
    id: "KGSIBy3iAEX6shhpSb4C",
    index: "newcodes 156",

    credits: 50,
  },
  {
    id: "iYRcxtiyTwcIqWjE8Pi0",
    index: "newcodes 157",

    credits: 50,
  },
  {
    id: "3sn1rY0mfv2da0YS5bN3",
    index: "newcodes 158",

    credits: 50,
  },
  {
    id: "wFUEiCQEEpgd5vqLDjeL",
    index: "newcodes 159",

    credits: 50,
  },
  {
    id: "YMefCpRu9zApnjlvEYeS",
    index: "newcodes 160",

    credits: 50,
  },
  {
    id: "d9r2KitqdBVQcFp66Tsz",
    index: "newcodes 161",

    credits: 50,
  },
  {
    id: "aPGMqAnxuTxC32nm9v9C",
    index: "newcodes 162",

    credits: 50,
  },
  {
    id: "9vchle39DuOBDQUqQzNd",
    index: "newcodes 163",
    credits: 50,
  },
];

export function downloadNewIds(filename = "utopiaIds") {
  const data = [];
  for (let i = 0; i < 100; i++) {
    const newId = generateFirebaseId();
    data.push({ id: newId, index: i + 1, credits: 50 });
  }

  // Export JSON
  const jsonBlob = new Blob([JSON.stringify(data, null, 2)], {
    type: "application/json",
  });
  const jsonHref = URL.createObjectURL(jsonBlob);
  const jsonLink = document.createElement("a");
  jsonLink.href = jsonHref;
  jsonLink.download = `${filename}.json`;
  document.body.appendChild(jsonLink);
  jsonLink.click();
  document.body.removeChild(jsonLink);
  URL.revokeObjectURL(jsonHref);

  // Convert data to worksheet
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

  // Export workbook to a Blob
  const workbookBlob = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });
  const xlsxBlob = new Blob([workbookBlob], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
  });
  const xlsxHref = URL.createObjectURL(xlsxBlob);
  const xlsxLink = document.createElement("a");
  xlsxLink.href = xlsxHref;
  xlsxLink.download = `${filename}.xlsx`;
  document.body.appendChild(xlsxLink);
  xlsxLink.click();
  document.body.removeChild(xlsxLink);
  URL.revokeObjectURL(xlsxHref);
}

interface WaitlistEntry {
  email: string;
  createdAt: string;
}

interface WaitlistData {
  id: string;
  index: string;
  credits: number;
  email: string;
  createdAt: string;
}

export const downloadWaitlist = async (filename = "waitlist") => {
  const data: WaitlistData[] = [];
  const utopiaGeneralRef = doc(db, "utopia/general");
  const utopiaGeneralSnapshot = await getDoc(utopiaGeneralRef);

  const utopiaGeneralDoc = utopiaGeneralSnapshot.data();

  if (utopiaGeneralDoc?.waitlist) {
    utopiaGeneralDoc.waitlist.forEach(
      ({ email, createdAt }: WaitlistEntry, i: number) => {
        const newId = generateFirebaseId();

        data.push({
          id: newId,
          index: `waitlist ${i + 1}`,
          credits: 50,
          email,
          createdAt,
        });
      },
    );
  }

  // Export JSON
  const jsonBlob = new Blob([JSON.stringify(data, null, 2)], {
    type: "application/json",
  });
  const jsonHref = URL.createObjectURL(jsonBlob);
  const jsonLink = document.createElement("a");
  jsonLink.href = jsonHref;
  jsonLink.download = `${filename}.json`;
  document.body.appendChild(jsonLink);
  jsonLink.click();
  document.body.removeChild(jsonLink);
  URL.revokeObjectURL(jsonHref);

  // Convert data to worksheet
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

  // Export workbook to a Blob
  const workbookBlob = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });
  const xlsxBlob = new Blob([workbookBlob], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
  });
  const xlsxHref = URL.createObjectURL(xlsxBlob);
  const xlsxLink = document.createElement("a");
  xlsxLink.href = xlsxHref;
  xlsxLink.download = `${filename}.xlsx`;
  document.body.appendChild(xlsxLink);
  xlsxLink.click();
  document.body.removeChild(xlsxLink);
  URL.revokeObjectURL(xlsxHref);
};
